import { setupFormState } from '@/components/form/tidal-form'

import { UserFormValues } from './types'

export const form = setupFormState<UserFormValues>({
  id: 'userForm',
  initialValues: {
    id: '',
    name: '',
    type: 'planner',
    email: '',
    limitedAccess: false,
    surname: '',
    enabled: true,
    username: '',
    territoryFilter: [],
    courierFilter: [],
    isCompanyFiltered: false,
    companies: [],
    'new-password': '',
    vehicles: {},
    drivers: {},
  },
})
